
































import NoResults from "@/components/ui/NoResults.vue";
import { Component} from "vue-property-decorator";
import BaseInternalTableValorization
    from "@/components/pages/valorizations/internal/observatory/BaseInternalTableValorization.vue";

@Component({
  components: { NoResults }
})
export default class NecessaryRequestsTable extends BaseInternalTableValorization {
  protected groups = {
    amphibian: {
      label: "Amphibiens",
      name: "amphibian"
    },

    chiropteres: {
      label: "Chauves-souris",
      name: "chiropteres"
    },

    coleopteres: {
      label: "Coléoptères",
      name: "coleopteres"
    },

    lepidopteres: {
      label: "Lépidoptères",
      name: "lepidopteres"
    },

    mammiferes_hors_chiro: {
      label: "Mammifères terrestres",
      name: "mammiferes_hors_chiro"
    },

    reptiles: {
      label: "Reptiles",
      name: "reptiles"
    },

    odonates: {
      label: "Odonates",
      name: "odonates"
    },

    orthopteres: {
      label: "Odonates",
      name: "orthopteres"
    },

    avifaune: {
      label: "Oiseaux",
      name: "avifaune"
    },

    all: {
      label: "Tous groupes faunistiques",
      name: "all"
    }
  };

  protected url = "/valorization/observatory/fauna/necessary-requests";

  drawData() {
    this.data = this.data.length > 0 ? this.data : [];
  }
}
